import { QueueSummaryResponse } from 'app/modules/queues/responses';

export enum NarrativeTemplateOwningTeamAvailability {
  ALL_TEAMS = 'ALL_TEAMS',
  RESTRICT_BY_TEAM = 'RESTRICT_BY_TEAM',
}

export enum NarrativeTemplateType {
  ALERT_NARRATIVE_TEMPLATE = 'ALERT_NARRATIVE_TEMPLATE',
  CASE_NARRATIVE_TEMPLATE = 'CASE_NARRATIVE_TEMPLATE',
}

// Filing narrative templates (`/narrative-templates/filings/*`) shared by SAR/FINTRAC settings.
export enum FilingNarrativeTemplateType {
  FINCEN_SAR = 'FINCEN_SAR',
  FINTRAC_STR = 'FINTRAC_STR',
}

export interface NarrativeTemplate {
  id: number;
  title: string;
  content: string;
  created_at: string | null;
  created_by_display_name: string;
  queues: QueueSummaryResponse[];
  type: NarrativeTemplateType;
  owning_team_ids: number[] | null;
}

export interface FilingNarrativeTemplate {
  id: number;
  tag_id: number | null;
  content: string;
  template_type?: string;
}
